import { cfgBrandTitle } from '@infinitro/config';
import { Verbiage, t } from '@infinitro/content';
import { isBannedUserStatus } from '@infinitro/global';
import { get } from 'svelte/store';
export { isBannedUserStatus };
export const bannedAccountMessage = () => {
    const translate = get(t);
    return translate(Verbiage.user_banned).replace('[BRAND]', cfgBrandTitle());
};
export const humanizeAuthError = (e) => {
    const raw = String(e ?? '');
    // UserBan error
    if (/AdminBan|BANNED/i.test(raw)) {
        return bannedAccountMessage();
    }
    return raw;
};
